import { BasicResponseDTO } from '@dto/basicResponse.dto';
import { AddRecentlySearchedDTO } from '@dto/recentlySearched.dto';
import { postApi } from 'src/util/apiCalls';

export const addRecentlySearchedQuery = async (
  userId: number,
  searchQuery: string
): Promise<void> => {
  const payload: AddRecentlySearchedDTO = {
    user_id: String(userId),
    search_query: searchQuery,
  };

  await postApi<BasicResponseDTO, AddRecentlySearchedDTO>(
    '/api/search/v1/recently_searched/add',
    payload
  );
};
